import React, {Component} from "react"
import "./App.css"

export default class App extends Component {
    render() {
        return (
            <div className="App">
                {this.props.children}
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/